import { useState, useEffect } from 'react';
import { supabase } from '../utils/supabaseClient';
import { useAuth } from '../contexts/AuthContext';
import { isSubscriptionTestModeEnabled } from '../utils/testingMode';

export function useSubscriptionStatus() {
  const { user } = useAuth();
  const [hasActiveSubscription, setHasActiveSubscription] = useState(false);
  const [hasLifetimeAccess, setHasLifetimeAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function checkSubscription() {
      if (isSubscriptionTestModeEnabled()) {
        setLoading(false);
        setHasActiveSubscription(true);
        setHasLifetimeAccess(true);
        return;
      }

      if (!user) {
        setLoading(false);
        setHasActiveSubscription(false);
        setHasLifetimeAccess(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('subscriptions')
          .select('*')
          .eq('user_id', user.id)
          .eq('status', 'active');

        if (error) throw error;

        const now = Math.floor(Date.now() / 1000);
        let hasActive = false;
        let hasLifetime = false;

        data?.forEach(subscription => {
          if (subscription.plan_type === 'lifetime') {
            hasActive = true;
            hasLifetime = true;
          } else {
            // Try all possible locations for period end
            const periodEnd =
            subscription?.current_period_end ||
              subscription.metadata?.current_period_end ||
              subscription.metadata?.subscription_details?.items?.data[0]?.current_period_end;
            if (periodEnd && periodEnd > now) {
              hasActive = true;
            }
          }
        });
        // //console.log('data', data);
        // //console.log('hasActive', hasActive);
        // //console.log('hasLifetime', hasLifetime);
        setHasActiveSubscription(hasActive);
        setHasLifetimeAccess(hasLifetime);
      } catch (err) {
        // //console.error('Error checking subscription:', err);
        setHasActiveSubscription(false);
        setHasLifetimeAccess(false);
      } finally {
        setLoading(false);
      }
    }

    checkSubscription();
  }, [user]);

  return { hasActiveSubscription, hasLifetimeAccess, loading };
} 
